import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/ui/Button'
import Input from '@/components/ui/Input'
import { authApi } from '@/services/api'
import styles from './PhoneEntry.module.css'

interface EmailEntryProps {
  onSwitchChannel?: () => void
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default function EmailEntry({ onSwitchChannel }: EmailEntryProps = {}) {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const trimmed = email.trim().toLowerCase()
  const isValidEmail = EMAIL_RE.test(trimmed)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (!isValidEmail) {
      setError('Please enter a valid email address')
      return
    }

    setLoading(true)

    try {
      const response = await authApi.requestEmailOTP(trimmed)
      sessionStorage.setItem('email', response.data.email)
      navigate('/verify-email')
    } catch {
      setError('Failed to send OTP. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Welcome to MelloMap</h1>
        <p className={styles.subtitle}>
          Enter your email to get started
        </p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={error}
          autoFocus
        />

        <Button
          type="submit"
          fullWidth
          size="lg"
          loading={loading}
          disabled={!isValidEmail}
        >
          Send OTP
        </Button>

        {onSwitchChannel && (
          <button
            type="button"
            className={styles.switchLink}
            onClick={onSwitchChannel}
          >
            In India? Use WhatsApp instead
          </button>
        )}

        <p className={styles.terms}>
          By continuing, you agree to our{' '}
          <a href="/terms" target="_blank">Terms of Service</a>
          {' '}and{' '}
          <a href="/privacy" target="_blank">Privacy Policy</a>
        </p>
      </form>
    </div>
  )
}
